// if ($('.page-top').length) {
//   $('.is-page-anchor').attr('data-fullScreenMenu-trigger', 'js-fullScreenMenu-content');
// }

// $('.l-header-fullScreenMenu-function__link').click(function () {
//   // $('a[href^="#"]').click(function () {
//   if ($(this).hasClass('is-page-anchor') && $('.page-top').length) {
//     // $('.is-backFixed').removeClass('is-open');
//     // $('html').css({
//     //   'position': '',
//     //   'top': '',
//     //   'width': '',
//     //   'height': '',
//     //   'overflow': ''
//     // });


//     // $('.fullScreenMenu-content').addClass('is-close');
//     // $('.fullScreenMenu-content').removeClass('is-open');
//     // $('.fullScreenMenu-content').attr('aria-hidden', 'true');
//     console.log('testetst');
//     // 移動先を0px調整する。0を30にすると30px下にずらすことができる。
//     var adjust = 0;
//     // スクロールの速度（ミリ秒）
//     var speed = 400;
//     // アンカーの値取得 リンク先（href）を取得して、hrefという変数に代入
//     var href = $(this).attr("href");
//     // 移動先を取得 リンク先(href）のidがある要素を探して、targetに代入
//     var target = $(href == "#" || href == "" ? 'html' : href);
//     // 移動先を調整 idの要素の位置をoffset()で取得して、positionに代入
//     var position = target.offset().top + adjust;
//     // スムーススクロール linear（等速） or swing（変速）
//     $('body,html').animate({ scrollTop: position }, speed, 'swing');
//     return false;
//   }
// });